import { configure, render, RenderOptions, RenderResult } from '@testing-library/react';
import React, { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n, initializeI18n, t } from 'src/js/i18n';
import { IconStatusType } from 'src/js/model/icon-status-type';

configure({ testIdAttribute: 'data-auto' });
initializeI18n(false);

interface Props {
  children?: ReactNode;
}

// TODO: Add theming here
const allTheProviders: React.FunctionComponent<Props> = ({ children }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);

const customRender: (ui: React.ReactElement, options?: Omit<RenderOptions, 'queries'>) => RenderResult = (
  ui,
  options,
) => render(ui, { wrapper: allTheProviders, ...options });

// re-export everything
export * from '@testing-library/react';

// override render method
export { customRender as render };
export { t };

export const randomNumber: () => number = () => Math.floor(Math.random() * Number.MAX_VALUE);

/* Test Types */
export const stoppedTypes: IconStatusType[] = [
  IconStatusType.ERROR,
  IconStatusType.INACTIVE,
  IconStatusType.OFFLINE,
  IconStatusType.PAUSED,
  IconStatusType.STOPPED,
];
export const startedTypes: IconStatusType[] = [
  IconStatusType.UNASSIGNED,
  IconStatusType.WARNING,
  IconStatusType.OK,
  IconStatusType.READY,
  IconStatusType.STARTING,
  IconStatusType.STOPPING,
  IconStatusType.STREAMING,
  IconStatusType.TO_STORAGE,
];
